import Vue from "vue";

Vue.mixin({
    data: function () {
        return {};
    },
    methods: {
        getImageUrl(fileName) {
            return require('./../assets/images/photo/' + fileName);
        }
    }
});
